import React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import moment from 'moment';
import { useAppSettings } from '../../modules/ui/hooks';

const useStyles = makeStyles(() => ({
  button: {
    color: 'inherit',
  },
}));

export default function LocaleSwitcher() {
  const classes = useStyles();
  const { settings } = useAppSettings();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  async function handleLocaleChange(locale: string) {
    await moment.locale(locale);
    await i18n.changeLanguage(locale);
    handleClose();
  }

  const { i18n } = useTranslation();

  return (
    <div>
      <Button
        className={classes.button}
        aria-controls="app-locale"
        aria-haspopup="true"
        onClick={handleClick}
      >
        {i18n.language.split('-')[0]}
      </Button>
      <Menu
        id="app-locale"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {settings.locales.map((locale: string) => (
          <MenuItem onClick={() => handleLocaleChange(locale)} key={locale}>
            {locale.toUpperCase()}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
